import dynamic from 'next/dynamic';
import type React from 'react';

import { RecommendationPlaceholder } from '@/productDiscovery/ProductPage/b2c/components/Recommendation/Recommendation.placeholder';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';
import { useSponsoredPlaylistData } from '@/productDiscovery/SponsoredProductRecommendation/modules/SponsoredProductRecommendation/hooks/useSponsoredPlaylistData';

const LazySponsoredPlaylist = dynamic(
  () => import('./SponsoredPlaylist').then((mod) => mod.default),
  {
    ssr: false,
    loading: () => <RecommendationPlaceholder />,
  },
);

export const SponsoredPlaylistContainer: React.FC = () => {
  const { productId } = useDetail();
  const sponsoredPlaylistData = useSponsoredPlaylistData();

  if (
    sponsoredPlaylistData &&
    sponsoredPlaylistData.fetched &&
    !sponsoredPlaylistData.data.length
  )
    return null;
  if (!sponsoredPlaylistData || !sponsoredPlaylistData.fetched)
    return <RecommendationPlaceholder />;

  return (
    <LazySponsoredPlaylist
      key={`sponsored-playlist-${productId}`}
      sponsoredData={sponsoredPlaylistData.data}
    />
  );
};

SponsoredPlaylistContainer.displayName = 'SponsoredPlaylistContainer';
